import React from 'react';
import styles from './Legal.module.css';
import Container from '../components/shared/Container';

const PrivacyPolicy = () => {
    return (
        <>
            <div className={styles.legalPage}>
                <Container>
                    <div className={styles.content}>
                        <h1>Privacyverklaring</h1>
                        <p className={styles.lastUpdated}>Laatst bijgewerkt: {new Date().toLocaleDateString('nl-BE')}</p>
                        
                        <section className={styles.section}>
                            <h2>1. Inleiding</h2>
                            <p>Resto-Online, handelsnaam van BrandVisionX, hecht veel waarde aan de bescherming van uw persoonsgegevens. In deze privacyverklaring willen we heldere informatie geven over hoe wij omgaan met uw persoonsgegevens.</p>
                            <p>Wij doen er alles aan om uw privacy te waarborgen en gaan daarom zorgvuldig om met persoonsgegevens. Resto-Online houdt zich in alle gevallen aan de toepasselijke wet- en regelgeving, waaronder de Algemene Verordening Gegevensbescherming (AVG).</p>
                        </section>

                        <section className={styles.section}>
                            <h2>2. Verwerkingsverantwoordelijke</h2>
                            <p>Resto-Online, handelsnaam van BrandVisionX, met maatschappelijke zetel te Tentoonstellingslaan 34 2020 Antwerpen, België, ingeschreven in de Kruispuntbank van Ondernemingen onder nummer BE 1007.972.431, is de verwerkingsverantwoordelijke voor de verwerking van uw persoonsgegevens.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>3. Welke gegevens verzamelen wij?</h2>
                            <p>Wij verzamelen de volgende persoonsgegevens:</p>
                            <ul>
                                <li><strong>Voor restaurants:</strong> Bedrijfsnaam, BTW-nummer, adres, contactpersoon, telefoonnummer, e-mailadres, bankgegevens</li>
                                <li><strong>Voor eindgebruikers/klanten:</strong> Naam, e-mailadres, telefoonnummer, bestelhistoriek, betaalgegevens</li>
                            </ul>
                        </section>

                        <section className={styles.section}>
                            <h2>4. Waarvoor gebruiken wij uw gegevens?</h2>
                            <p>Wij verwerken uw persoonsgegevens voor de volgende doeleinden:</p>
                            <ul>
                                <li>Het afhandelen van bestellingen en betalingen</li>
                                <li>Het faciliteren van communicatie tussen restaurants en klanten</li>
                                <li>Het verbeteren van onze dienstverlening</li>
                                <li>Het voldoen aan wettelijke verplichtingen</li>
                                <li>Het verzenden van nieuwsbrieven (alleen met uw expliciete toestemming)</li>
                            </ul>
                        </section>

                        <section className={styles.section}>
                            <h2>5. Bewaartermijn</h2>
                            <p>Resto-Online bewaart uw persoonsgegevens niet langer dan strikt noodzakelijk is om de doelen te realiseren waarvoor uw gegevens worden verzameld.</p>
                            <ul>
                                <li>Gegevens van restaurants bewaren wij voor de duur van de samenwerking en tot maximaal 7 jaar na beëindiging hiervan (in verband met fiscale bewaarplicht).</li>
                                <li>Gegevens van eindgebruikers/klanten bewaren wij tot maximaal 2 jaar na de laatste bestelling.</li>
                            </ul>
                        </section>

                        <section className={styles.section}>
                            <h2>6. Delen van persoonsgegevens met derden</h2>
                            <p>Resto-Online deelt uw persoonsgegevens alleen met derden als dit noodzakelijk is voor het uitvoeren van de overeenkomst of om te voldoen aan een wettelijke verplichting.</p>
                            <p>Met bedrijven die uw gegevens verwerken in onze opdracht, sluiten wij een verwerkersovereenkomst om te zorgen voor eenzelfde niveau van beveiliging en vertrouwelijkheid van uw gegevens.</p>
                            <p>Wij maken gebruik van de volgende externe dienstverleners:</p>
                            <ul>
                                <li>Stripe voor betalingsverwerking</li>
                                <li>Resend voor e-mailcommunicatie</li>
                            </ul>
                        </section>

                        <section className={styles.section}>
                            <h2>7. Cookies</h2>
                            <p>Resto-Online gebruikt functionele, analytische en tracking cookies. Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen in de browser van uw computer, tablet of smartphone.</p>
                            <p>U kunt zich afmelden voor cookies door uw internetbrowser zo in te stellen dat deze geen cookies meer opslaat. Daarnaast kunt u ook alle informatie die eerder is opgeslagen via de instellingen van uw browser verwijderen.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>8. Beveiliging</h2>
                            <p>Resto-Online neemt de bescherming van uw gegevens serieus en neemt passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan.</p>
                            <p>Als u de indruk heeft dat uw gegevens niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan contact op via info@brandvisionx.be.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>9. Uw rechten</h2>
                            <p>U heeft het recht om uw persoonsgegevens in te zien, te corrigeren of te verwijderen. Daarnaast heeft u het recht om uw eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen de verwerking van uw persoonsgegevens door Resto-Online.</p>
                            <p>U kunt een verzoek tot inzage, correctie, verwijdering of overdracht van uw persoonsgegevens sturen naar info@brandvisionx.be. Om er zeker van te zijn dat het verzoek door u is gedaan, vragen wij u een kopie van uw identiteitsbewijs met het verzoek mee te sturen.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>10. Wijzigingen</h2>
                            <p>Resto-Online behoudt zich het recht voor om wijzigingen aan te brengen in deze privacyverklaring. Controleer daarom regelmatig deze privacyverklaring.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>11. Contact</h2>
                            <p>Als u vragen heeft over deze privacyverklaring, neem dan contact op via:</p>
                            <p>
                                BrandVisionX<br />
                                Tentoonstellingslaan 34<br />
                                2020 Antwerpen<br />
                                België<br />
                                E-mail: info@brandvisionx.be
                            </p>
                        </section>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default PrivacyPolicy; 